import { render, staticRenderFns } from "./NavigationBarProfile.vue?vue&type=template&id=859db66e"
import script from "./NavigationBarProfile.vue?vue&type=script&lang=js"
export * from "./NavigationBarProfile.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarProfile.vue?vue&type=style&index=0&id=859db66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports